import PropTypes from "prop-types";
import classNames from "classnames";
import { ORDER_COLUMNS } from "../../constants/table";
import Table from "../Table/Table";
import TablePriceCell from "../Table/TablePriceCell/TablePriceCell";
import Price from "../Price/Price";
import classes from "./OrderDetails.module.css";

const OrderDetails = (props) => {
  const { id, total, deliveryFees, skus, bundles } = props;

  const getTableData = (list, isSku) => {
    return list.map((listItem) => {
      const { name, skuBrandName, price, quantity, total } = listItem;
      return {
        name: (
          <div className={classes["order-details__name-wrapper"]}>
            {isSku && skuBrandName ? (
              <p className={classes["order-details__name-title"]}>
                {skuBrandName}
              </p>
            ) : !isSku ? (
              <p className={classes["order-details__name-title"]}>
                "مجموعة عرض"
              </p>
            ) : null}

            <p className={classes["order-details__name"]}>{name}</p>
          </div>
        ),
        price: <TablePriceCell price={price} />,
        quantity: (
          <span
            className={classNames(
              classes["order-details__quantity"],
              "numeric-content"
            )}
          >
            {quantity}
          </span>
        ),
        total: <TablePriceCell price={total} />,
      };
    });
  };

  return (
    <div>
      <p className={classes["order-details__id-wrapper"]}>
        <span className={classes["order-details__id-text"]}>رقم الطلب #</span>
        <span
          className={classNames(
            classes["order-details__id"],
            "numeric-content"
          )}
        >
          {id}
        </span>
      </p>
      <Table
        columns={ORDER_COLUMNS}
        data={[...getTableData(skus, true), ...getTableData(bundles, false)]}
      />
      <div className={classes["order-details__total-wrapper"]}>
        <div className={classes["order-details__total-wrapper__row"]}>
          <p className={classes["order-details__total-text"]}>رسوم التوصيل</p>
          <Price
            value={deliveryFees}
            suffix="جم"
            className={classes["order-details__total-number-wrapper"]}
            valueClassName={classes["order-details__total-number"]}
            suffixClassName={classes["order-list-item__total-currency"]}
          />
        </div>
        <div className={classes["order-details__total-wrapper__row"]}>
          <p className={classes["order-details__total-text"]}>الاجمالي</p>
          <Price
            value={total}
            suffix="جم"
            className={classes["order-details__total-number-wrapper"]}
            valueClassName={classes["order-details__total-number"]}
            suffixClassName={classes["order-list-item__total-currency"]}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;

OrderDetails.propTypes = {
  id: PropTypes.number,
  total: PropTypes.number,
  deliveryFees: PropTypes.number,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      skuBrandName: PropTypes.string,
      price: PropTypes.number,
      quantity: PropTypes.number,
      total: PropTypes.number,
    })
  ),
  bundles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      quantity: PropTypes.number,
      total: PropTypes.number,
    })
  ),
};
